import axiosInstance from 'helpers/axiosInstance';

export interface GetPaymentContextResponse {
  publishableKey: string;
}

export const getPaymentContext = (patientId: string) => {
  const url = `/patients/payments/context?patient_id=${patientId}`;
  return axiosInstance
    .get<GetPaymentContextResponse>(url)
    .then(response => response.data);
};
